import { useRouteError } from "react-router-dom";

export const ErrorView = () => {
	const error = useRouteError();

	return <div>{error.statusText || error.message}</div>;
};
